export default __webpack_public_path__ + "static/media/BankAcc.bae80eb0.svg";